import definition from './chars.service';

/**
 * GeoService settings
 * @type {{name: string, definition: GeoService}}
 */

export default {
    name: 'CharsService',
    definition
};



// WEBPACK FOOTER //
// ./app/services/chars/index.js